import { render, staticRenderFns } from "./PreviewTestTimeUpModal.vue?vue&type=template&id=12dc9458&"
import script from "./PreviewTestTimeUpModal.vue?vue&type=script&lang=js&"
export * from "./PreviewTestTimeUpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports